import { isAfter, isBefore, isEqual } from "date-fns";

export default function isDateInBetween(date:Date,initialDate:Date,endDate:Date) : boolean {

	return (isBefore(date, endDate) || isEqual(date, endDate)) && 
        (isAfter(date, initialDate)|| isEqual(date, initialDate));
}
